import {css} from 'lit';

export const inputOnDarkStyles = css`
  --_input__color: var(--sbkInputFgColorOnLightDefault);
  --_input__color--disabled: var(--sbkInputFgColorOnDarkDisabled);
  --_input__color--error: var(--sbkInputFgColorOnDarkError);

  --_input__bg: var(--sbkInputBgColorOnDarkEnabled);
  --_input__bg--active: var(--sbkInputBgColorOnDarkActive);
  --_input__bg--hover: var(--sbkInputBgColorOnDarkHover);
  --_input__bg--focus: var(--sbkInputBgColorOnDarkFocus);
  --_input__bg--disabled: var(--sbkInputBgColorOnDarkDisabled);
  --_input__bg--error: var(--sbkInputBgColorOnDarkError);
    
  --_input__border: var(--sbkInputBorderOnDarkEnabled);
  --_input__border--active: var(--sbkInputBorderOnDarkActive);
  --_input__border--disabled: var(--sbkInputBorderOnDarkDisabled);
  --_input__border--error: var(--sbkInputBorderOnDarkError);
  --_input__border--focus: var(--sbkInputBorderOnDarkFocus);
  --_input__border--hover: var(--sbkInputBorderOnDarkHover);
  --_input__border--readonly: var(--sbkInputBorderOnDarkDisabled);;
`;
